// removed by extract-text-webpack-plugin
module.exports = {"avatarBox":"dUI0lEdlvooX1miOinj6h","avatar":"_3241B404F3cG4pgnbytKxt","bullet":"_1lXVEzGmFQMAFEqLZE0obc","link":"_1lxvb8e8InEDyWpJuBiWso"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Avatar/style.css
// module id = 224
// module chunks = 42